import { serviceApi, tokenRepository, withServiceRequestDefaults } from 'Shared/network';
import { useQueryClient } from '@tanstack/react-query';
import type { ErrorResponse, MutationParam } from 'viewup-lib/common';
import { removeLocalStorage } from 'viewup-lib/common';
import { useSDMutation } from 'viewup-lib/react';

export const useLogout = (params: MutationParam<unknown, ErrorResponse, unknown>) => {
  const queryClient = useQueryClient();
  const { mutate: logout, isPending } = useSDMutation({
    ...params?.options,
    mutationFn: async () => {
      await serviceApi.auth.postUserLogout(withServiceRequestDefaults());
    },
    onSuccess: async (response, variables, context) => {
      removeLocalStorage('auto-click');
      tokenRepository.removeToken();
      queryClient.clear();

      if (params?.options?.onSuccess) {
        await params.options.onSuccess(response, variables, context);
      }
    },
  });

  return {
    isLoading: isPending,
    logout,
  };
};
